import { DateTime } from 'luxon';

export const getFormattedDate = (timeZone, formatRule) =>
    DateTime.fromMillis(Date.now(), { zone: timeZone }).toFormat(formatRule);
